// extracted by mini-css-extract-plugin
export default {"container":"ProductSorting_container__hZAoD"};